import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, db } from '../firebase/firebase';

let unsubscribeInquiryWatch: (() => void) | null = null;
let seenInquiryIds = new Set<string>();
let audioUnlocked = false;

function unlockAudio() {
  audioUnlocked = true;
  window.removeEventListener('click', unlockAudio);
  window.removeEventListener('keydown', unlockAudio);
}

window.addEventListener('click', unlockAudio);
window.addEventListener('keydown', unlockAudio);

function beep() {
  try {
    if (!audioUnlocked) return;
    const AudioContextClass = window.AudioContext || (window as any).webkitAudioContext;
    if (!AudioContextClass) return;

    const ctx = new AudioContextClass();
    const oscillator = ctx.createOscillator();
    const gain = ctx.createGain();

    oscillator.type = 'sine';
    oscillator.frequency.value = 880;
    gain.gain.value = 0.08;

    oscillator.connect(gain);
    gain.connect(ctx.destination);
    oscillator.start();

    setTimeout(() => {
      oscillator.stop();
      ctx.close();
    }, 220);
  } catch {}
}

async function notify(title: string, body: string) {
  beep();

  try {
    if (!('Notification' in window)) return;

    if (Notification.permission === 'default') {
      await Notification.requestPermission();
    }

    if (Notification.permission === 'granted') {
      new Notification(title, {
        body,
        icon: '/assets/logo.png',
        tag: title + body
      });
    }
  } catch {}
}

function startInquiryWatch(uid: string) {
  if (unsubscribeInquiryWatch) unsubscribeInquiryWatch();

  const inquiryQuery = query(collection(db, 'inquiries'), where('assignedUserId', '==', uid));

  unsubscribeInquiryWatch = onSnapshot(inquiryQuery, (snapshot) => {
    snapshot.docChanges().forEach((change) => {
      const data = change.doc.data() as any;
      const id = change.doc.id;

      if (!seenInquiryIds.has(id)) {
        seenInquiryIds.add(id);
        return;
      }

      if (change.type === 'added' || change.type === 'modified') {
        const clientName = data.clientSnapshot?.name || data.clientName || 'Client';
        const inquiryCode = data.inquiryCode || 'Inquiry';
        notify('New assigned inquiry', `${inquiryCode} - ${clientName}`);
      }
    });
  }, (error) => {
    console.warn('Inquiry assignment notification watch failed:', error);
  });
}

onAuthStateChanged(auth, (user) => {
  if (!user) {
    if (unsubscribeInquiryWatch) unsubscribeInquiryWatch();
    unsubscribeInquiryWatch = null;
    seenInquiryIds = new Set<string>();
    return;
  }

  startInquiryWatch(user.uid);
});

export {};
